/**
 * @author      [leiling.cp]
 * @version     [1.0.0]
 * @dete        [2015/3/20]
 * @description [主动营销二期]
 */

var $ = require("@alife/alpha-jquery/jquery"),
    Widget = require("@alife/alpha-widget/widget"),
    Util = require("./util"),
    AlipushClient = require("@alife/alpha-alipush-client/alipush-client-custom"),
    GData = require("@alife/alpha-gdata/gdata.js"),
    MessageBox = require("./message-box.js");

var MessageList = Widget.extend({
    attrs: {
        uid: Util.getUserId() || '',
        page: 'webDetail',
        contactId: GData.get('enMemberId') || '',
        contactName: (!GData.get('SupplierOnline') ? 'Supplier' : GData.get('SupplierOnline').contactName),
        contactImg: (!GData.get('SupplierOnline') ? '' : GData.get('SupplierOnline').photoUrl),
        productId: GData.get('productId') || '',
        parentNode: 'body',
        atmMod: null,
        weblite: false
    },
    parseElement: function() {
        var self = this;
        var atmMod = self.get('atmMod');

        self.element = $('<div class="initiative-sugguestion-list" id="initiative-sugguestion-list"></div>');

        if (atmMod) {
            self.element.addClass('with-toolbar');
        }
    },
    fixPosition: function() {
        if (this.get('isWeblite')) {
            this.element.css({
                right: 10,
                bottom: 20
            });
            return;
        }

        // ====== end =========
        var atmMod = this.get('atmMod');
        if (!atmMod) {
            return;
        }

        var pos = atmMod.getPosition();
        var bottom = $(window).height() - pos.top - pos.height;

        this.element.css({
            right: pos.width + 10,
            bottom: bottom
        });
    },
    setup: function() {
        var self = this;
        var atmMod = self.get('atmMod');

        // 延时发送判断是否进行主动营销
        var timer = setTimeout(function() {
            if (self.get('page') == 'productDetail') {
                $.getJSON('//mktplatform.alibaba.com/mkplatform/trigger.jsonp?productId=' + self.get('productId') + '&src=miniDetail&callback=?', function(json) {});
            } else {
                $.getJSON('//mktplatform.alibaba.com/mkplatform/trigger.jsonp?productId=' + self.get('productId') + '&src=detail&callback=?', function(json) {});
            }
        }, 60000);

        // bind events

        if (atmMod) {
            atmMod.on('popupPositionChange', function() {
                self.fixPosition();
            });

            $(window).resize(function() {
                self.fixPosition();
            });
        }

        self.render();
    },
    render: function() {
        MessageList.superclass.render.call(this);

        var self = this;

        new AlipushClient({
            uid: Util.getCookie('cna')
        }).on('message', function(data) {
            if (data.bid === 'MARKETING-DetailMarketingEvent') {
                self.renderBox(data.body);
            }
        });

        self.fixPosition();
        return self;
    },
    renderBox: function(data) {
        var self = this,
            result = {};

        if (!!data) {
            try {
                result = JSON.parse(data);
            } catch (e) {
                result = {};
            }
        }

        /**
         * result:
         * {
         *   country: 'us',
         *   eventId: 123,
         *   message: 'test'
         *   originTime: 1552377956805
         *   productId: 60815383540
         * }
         * 营销弹窗的图片self.get('contactImg')是detail传过来的, 发布产品的供应商旺旺头像
         */
        new MessageBox({
            page: self.get('page'),
            uid: self.get('uid'),
            marketingId: result.marketingId || result.eventId,
            contactId: result.contactId || self.get('contactId'),
            contactName: self.get('contactName'),
            contactImg: result.contactImg || self.get('contactImg'),
            productId: result.productId || self.get('productId'),
            destProductId: result.destProductId || '',
            parentNode: '#initiative-sugguestion-list',
            message: result.message || 'Hello, what can i do for you?',
            marketType: result.source || '',
            country: result.country || '',
            originTime: result.originTime || '',
            isWeblite: self.get('isWeblite'),
            messageInstance: this
        });
    }
});

module.exports = MessageList;
